import { PageCreditAccount } from "@components/modules/credit-account/detail/PageCreditAccountDetail";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { type WithIdProps, withId } from "@src/components/HOC/with-id/withId";
import { NavigationCreditAccountDetail } from "@src/components/widgets/AppSubNav/navigation-credit-accounts";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Credit account`}
    navigation={<NavigationCreditAccountDetail creditAccountId={id} />}
  >
    <PageCreditAccount />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/credit-accounts/detail")({
  component: RouteComponent,
});
